import React, { createContext, useContext, useState } from "react";

const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {

  const [activities, setActivities] = useState([]);

  const addActivity = (activityData) => {

    const newActivity = {
      activity: activityData.activity,
      time: new Date().toLocaleTimeString(),
      date: new Date()
    };

    setActivities((prev) => [...prev, newActivity]);
  };

  return (
    <ActivityContext.Provider value={{ activities, addActivity }}>
      {children}
    </ActivityContext.Provider>
  );
};

export const useActivity = () => {
  return useContext(ActivityContext);
};